import Cookies from 'js-cookie'

export default class CookieBar {

    constructor() {
        this.bar = document.querySelector('[data-cookie-bar]');
        this.close_btn = document.querySelector('[data-cookie-bar]');
        this.cookie_name = 'pp-cookie';
        this.cookie_exists = false;
    }

    init() {
        if (!this.bar || !this.close_btn) {
            return false;
        }

        this.cookie_exists = Cookies.get(this.cookie_name);

        if (this.cookie_exists) {
            this.bar.style.display = 'none';
            return true;
        } else {
            this.bar.style.opacity = '1';
            this.setListener();
        }
    }

    acceptCookie() {
        Cookies.set(this.cookie_name, 'accepted', { expires: 30 })
        this.hideCookieBar();
    }

    hideCookieBar() {
        this.bar.style.transform = 'translateY(120%)';
    }

    setListener() {
        this.close_btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.acceptCookie();
        });
    }

    // autoAccept() {
    //     setTimeout(() => {
    //       this.acceptCookie();
    //     }, 20000)
    // }

}
